<template>
  <b-row>
    <b-col md="2" class="d-flex justify-content-end">
      <b-button variant="primary" @click="redirectToWebsite">
        Visit Website
      </b-button>
    </b-col>
  </b-row>
</template>

<script>

import {
  BRow,
  BCol,
  BButton,
} from "bootstrap-vue";

import { mapActions, mapGetters } from "vuex";
export default {

    components: {
    BRow,
    BCol,
    BButton,
  },

    methods: {
        redirectToWebsite() {
      const tenantName = localStorage.getItem("userTenant");
      if (tenantName) {
        const Url = `${process.env.VUE_APP_BI_URL}`;

        window.open(Url, "_blank");
      } else {
        alert("Tenant name not found!");
      }
    },
    }

}
</script>
